import { useEffect } from "react";
import "./PlanSelection.scss";

const PlanSelection = ({ values, setFieldValue }) => {
  const allPlans = [
    {
      name: "Basic",
      price: 9.99,
      features: [
        "Access to 50 videos",
        "Standard video quality",
        "Email support",
      ],
    },
    {
      name: "Standard",
      price: 19.99,
      features: [
        "Access to 200 videos",
        "HD video quality",
        "Priority email support",
        "Downloadable content",
      ],
    },
    {
      name: "Premium",
      price: 29.99,
      features: [
        "Unlimited video access",
        "Full Access Every Tip & Tool Video",
        "Priority support",
        "Full Access to Downloadable PDF Project Plans!",
        "Full Access to Premium Seminars, Classes, and Technique Videos",
      ],
    },
    {
      name: "eNotes Unlimited",
      price: 9.95,
      features: [
        "Unlimited video access",
        "Full Access Every Tip & Tool Video",
        "Priority support",
        "Full Access to Downloadable PDF Project Plans!",
        "Full Access to Premium Seminars, Classes, and Technique Videos",
      ],
    },
  ];

  // Filter the array to get only the desired plan
  const unlimitedPlan = allPlans.find(
    (plan) => plan.name === "eNotes Unlimited"
  );
  const plansToShow = unlimitedPlan ? [unlimitedPlan] : [];

  // Set "eNotes Unlimited" as the default selected plan on component mount
  useEffect(() => {
    if (unlimitedPlan && values?.plan !== unlimitedPlan.name) {
      setFieldValue("plan", unlimitedPlan.name);
    }
  }, [unlimitedPlan, setFieldValue, values?.plan]);

  return (
    <div className="plans-selection">
      <h3>
        eNotes Unlimited <span className="member-price-plan">$9.95/year</span>
      </h3>
      <div className="plans-grid">
        {plansToShow?.map((plan) => (
          <div
            key={plan.name}
            className={`plan-card active`}
            onClick={() => setFieldValue("plan", plan.name)}
          >
            <ul className="plan-features">
              {plan?.features?.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlanSelection;